"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconGroups = exports["default"] = void 0;
var _addMoney = _interopRequireDefault(require("./add-money"));
var _arrowUpRight = _interopRequireDefault(require("./arrow-up-right"));
var _autoReload = _interopRequireDefault(require("./auto-reload"));
var _bike = _interopRequireDefault(require("./bike"));
var _birthday = _interopRequireDefault(require("./birthday"));
var _car = _interopRequireDefault(require("./car"));
var _caretDown = _interopRequireDefault(require("./caret-down"));
var _caretDownCircle = _interopRequireDefault(require("./caret-down-circle"));
var _caretDownCircleSolid = _interopRequireDefault(require("./caret-down-circle-solid"));
var _cautionSolid = _interopRequireDefault(require("./caution-solid"));
var _cellPhone = _interopRequireDefault(require("./cell-phone"));
var _check = _interopRequireDefault(require("./check"));
var _checkSolid = _interopRequireDefault(require("./check-solid"));
var _chevronLeft = _interopRequireDefault(require("./chevron-left"));
var _chevronRight = _interopRequireDefault(require("./chevron-right"));
var _circularArrow = _interopRequireDefault(require("./circular-arrow"));
var _close = _interopRequireDefault(require("./close"));
var _closeSolid = _interopRequireDefault(require("./close-solid"));
var _clover = _interopRequireDefault(require("./clover"));
var _coupon = _interopRequireDefault(require("./coupon"));
var _creditCard = _interopRequireDefault(require("./credit-card"));
var _digitalPayment = _interopRequireDefault(require("./digital-payment"));
var _digitalRewards = _interopRequireDefault(require("./digital-rewards"));
var _directions = _interopRequireDefault(require("./directions"));
var _evenings = _interopRequireDefault(require("./evenings"));
var _externalLink = _interopRequireDefault(require("./external-link"));
var _eyeClosed = _interopRequireDefault(require("./eye-closed"));
var _eyeOpen = _interopRequireDefault(require("./eye-open"));
var _filledCard = _interopRequireDefault(require("./filled-card"));
var _fizzio = _interopRequireDefault(require("./fizzio"));
var _gear = _interopRequireDefault(require("./gear"));
var _geolocate = _interopRequireDefault(require("./geolocate"));
var _groceryCode = _interopRequireDefault(require("./grocery-code"));
var _hamburger = _interopRequireDefault(require("./hamburger"));
var _heart = _interopRequireDefault(require("./heart"));
var _heartSolid = _interopRequireDefault(require("./heart-solid"));
var _twentyFourHours = _interopRequireDefault(require("./twenty-four-hours"));
var _info = _interopRequireDefault(require("./info"));
var _laBoulange = _interopRequireDefault(require("./la-boulange"));
var _lifeSaver = _interopRequireDefault(require("./life-saver"));
var _link = _interopRequireDefault(require("./link"));
var _lock = _interopRequireDefault(require("./lock"));
var _lockFilled = _interopRequireDefault(require("./lock-filled"));
var _magicWand = _interopRequireDefault(require("./magic-wand"));
var _maskClear = _interopRequireDefault(require("./mask-clear"));
var _mercato = _interopRequireDefault(require("./mercato"));
var _minusCircle = _interopRequireDefault(require("./minus-circle"));
var _minusCircleSolid = _interopRequireDefault(require("./minus-circle-solid"));
var _minusCircleThin = _interopRequireDefault(require("./minus-circle-thin"));
var _minus = _interopRequireDefault(require("./minus"));
var _mobileOrdering = _interopRequireDefault(require("./mobile-ordering"));
var _mobileOrderPay = _interopRequireDefault(require("./mobile-order-pay"));
var _moonZzz = _interopRequireDefault(require("./moon-zzz"));
var _nitroBrew = _interopRequireDefault(require("./nitro-brew"));
var _oleato = _interopRequireDefault(require("./oleato"));
var _openNow = _interopRequireDefault(require("./open-now"));
var _ovenWarmed = _interopRequireDefault(require("./oven-warmed"));
var _pencil = _interopRequireDefault(require("./pencil"));
var _personal = _interopRequireDefault(require("./personal"));
var _phone = _interopRequireDefault(require("./phone"));
var _pickupCurbside = _interopRequireDefault(require("./pickup-curbside"));
var _pickupDriveThru = _interopRequireDefault(require("./pickup-drive-thru"));
var _pickupInStore = _interopRequireDefault(require("./pickup-in-store"));
var _pickupOutdoor = _interopRequireDefault(require("./pickup-outdoor"));
var _pin = _interopRequireDefault(require("./pin"));
var _pinFilled = _interopRequireDefault(require("./pin-filled"));
var _plus = _interopRequireDefault(require("./plus"));
var _plusCircle = _interopRequireDefault(require("./plus-circle"));
var _plusCircleSolid = _interopRequireDefault(require("./plus-circle-solid"));
var _powermat = _interopRequireDefault(require("./powermat"));
var _profile = _interopRequireDefault(require("./profile"));
var _receipt = _interopRequireDefault(require("./receipt"));
var _redeemRewards = _interopRequireDefault(require("./redeem-rewards"));
var _reserve = _interopRequireDefault(require("./reserve"));
var _rightArrowCircle = _interopRequireDefault(require("./right-arrow-circle"));
var _scroll = _interopRequireDefault(require("./scroll"));
var _search = _interopRequireDefault(require("./search"));
var _seatingCafe = _interopRequireDefault(require("./seating-cafe"));
var _seatingOutdoor = _interopRequireDefault(require("./seating-outdoor"));
var _socialMediaFacebook = _interopRequireDefault(require("./social-media-facebook"));
var _socialMediaInstagram = _interopRequireDefault(require("./social-media-instagram"));
var _socialMediaPinterest = _interopRequireDefault(require("./social-media-pinterest"));
var _socialMediaSpotify = _interopRequireDefault(require("./social-media-spotify"));
var _socialMediaTwitter = _interopRequireDefault(require("./social-media-twitter"));
var _socialMediaYoutube = _interopRequireDefault(require("./social-media-youtube"));
var _sparkles = _interopRequireDefault(require("./sparkles"));
var _star = _interopRequireDefault(require("./star"));
var _starbucksCard = _interopRequireDefault(require("./starbucks-card"));
var _starShower = _interopRequireDefault(require("./star-shower"));
var _store = _interopRequireDefault(require("./store"));
var _svcCard = _interopRequireDefault(require("./svc-card"));
var _tipJar = _interopRequireDefault(require("./tip-jar"));
var _transfer = _interopRequireDefault(require("./transfer"));
var _transit = _interopRequireDefault(require("./transit"));
var _trophy = _interopRequireDefault(require("./trophy"));
var _user = _interopRequireDefault(require("./user"));
var _verismo = _interopRequireDefault(require("./verismo"));
var _voidIcon = _interopRequireDefault(require("./void-icon"));
var _walk = _interopRequireDefault(require("./walk"));
var _warning = _interopRequireDefault(require("./warning"));
var _warningSolid = _interopRequireDefault(require("./warning-solid"));
var _wifi = _interopRequireDefault(require("./wifi"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/*
 * Index of global icon paths used for generating documentation.
 * Don't use this file in an app. Import individual icon path files instead.
 */

// void is reserved JS word

var paths = {
  addMoney: _addMoney["default"],
  arrowUpRight: _arrowUpRight["default"],
  autoReload: _autoReload["default"],
  bike: _bike["default"],
  birthday: _birthday["default"],
  car: _car["default"],
  caretDown: _caretDown["default"],
  caretDownCircle: _caretDownCircle["default"],
  caretDownCircleSolid: _caretDownCircleSolid["default"],
  cautionSolid: _cautionSolid["default"],
  cellPhone: _cellPhone["default"],
  check: _check["default"],
  checkSolid: _checkSolid["default"],
  chevronLeft: _chevronLeft["default"],
  chevronRight: _chevronRight["default"],
  circularArrow: _circularArrow["default"],
  close: _close["default"],
  closeSolid: _closeSolid["default"],
  clover: _clover["default"],
  coupon: _coupon["default"],
  creditCard: _creditCard["default"],
  digitalPayment: _digitalPayment["default"],
  digitalRewards: _digitalRewards["default"],
  // duplicate: deprecate redeemRewards
  directions: _directions["default"],
  evenings: _evenings["default"],
  externalLink: _externalLink["default"],
  eyeClosed: _eyeClosed["default"],
  eyeOpen: _eyeOpen["default"],
  filledCard: _filledCard["default"],
  fizzio: _fizzio["default"],
  gear: _gear["default"],
  geolocate: _geolocate["default"],
  groceryCode: _groceryCode["default"],
  hamburger: _hamburger["default"],
  heart: _heart["default"],
  heartSolid: _heartSolid["default"],
  info: _info["default"],
  laBoulange: _laBoulange["default"],
  lifeSaver: _lifeSaver["default"],
  link: _link["default"],
  lock: _lock["default"],
  lockFilled: _lockFilled["default"],
  magicWand: _magicWand["default"],
  mask: _maskClear["default"],
  mercato: _mercato["default"],
  minus: _minus["default"],
  minusCircle: _minusCircle["default"],
  minusCircleSolid: _minusCircleSolid["default"],
  minusCircleThin: _minusCircleThin["default"],
  mobileOrdering: _mobileOrdering["default"],
  // duplicate: deprecate mobileOrderPay
  mobileOrderPay: _mobileOrderPay["default"],
  // duplicate: deprecate mobileOrderPay
  moonZzz: _moonZzz["default"],
  nitroBrew: _nitroBrew["default"],
  oleato: _oleato["default"],
  openNow: _openNow["default"],
  ovenWarmed: _ovenWarmed["default"],
  pencil: _pencil["default"],
  personal: _personal["default"],
  phone: _phone["default"],
  pickupDriveThru: _pickupDriveThru["default"],
  pickupInStore: _pickupInStore["default"],
  pickupCurbside: _pickupCurbside["default"],
  pickupOutdoor: _pickupOutdoor["default"],
  pin: _pin["default"],
  pinFilled: _pinFilled["default"],
  plus: _plus["default"],
  plusCircle: _plusCircle["default"],
  plusCircleSolid: _plusCircleSolid["default"],
  powermat: _powermat["default"],
  profile: _profile["default"],
  receipt: _receipt["default"],
  redeemRewards: _redeemRewards["default"],
  // duplicate: deprecate redeemRewards
  reserve: _reserve["default"],
  rightArrowCircle: _rightArrowCircle["default"],
  scroll: _scroll["default"],
  search: _search["default"],
  seatingCafe: _seatingCafe["default"],
  seatingOutdoor: _seatingOutdoor["default"],
  socialMediaFacebook: _socialMediaFacebook["default"],
  socialMediaInstagram: _socialMediaInstagram["default"],
  socialMediaPinterest: _socialMediaPinterest["default"],
  socialMediaSpotify: _socialMediaSpotify["default"],
  socialMediaTwitter: _socialMediaTwitter["default"],
  socialMediaYoutube: _socialMediaYoutube["default"],
  sparkles: _sparkles["default"],
  star: _star["default"],
  starbucksCard: _starbucksCard["default"],
  // duplicate: deprecate svcCard
  starShower: _starShower["default"],
  store: _store["default"],
  svcCard: _svcCard["default"],
  // duplicate: deprecate svcCard
  tipJar: _tipJar["default"],
  transfer: _transfer["default"],
  transit: _transit["default"],
  trophy: _trophy["default"],
  twentyFourHours: _twentyFourHours["default"],
  user: _user["default"],
  verismo: _verismo["default"],
  "void": _voidIcon["default"],
  walk: _walk["default"],
  warning: _warning["default"],
  warningSolid: _warningSolid["default"],
  wifi: _wifi["default"]
};
var iconGroups = exports.iconGroups = {
  'Web Functionality': {
    eyeClosed: _eyeClosed["default"],
    eyeOpen: _eyeOpen["default"],
    gear: _gear["default"],
    hamburger: _hamburger["default"],
    link: _link["default"],
    lock: _lock["default"],
    lockFilled: _lockFilled["default"],
    pencil: _pencil["default"],
    pin: _pin["default"],
    pinFilled: _pinFilled["default"],
    profile: _profile["default"],
    search: _search["default"],
    user: _user["default"]
  },
  Marks: {
    cautionSolid: _cautionSolid["default"],
    check: _check["default"],
    checkSolid: _checkSolid["default"],
    close: _close["default"],
    closeSolid: _closeSolid["default"],
    info: _info["default"],
    minus: _minus["default"],
    minusCircle: _minusCircle["default"],
    minusCircleSolid: _minusCircleSolid["default"],
    minusCircleThin: _minusCircleThin["default"],
    plus: _plus["default"],
    plusCircle: _plusCircle["default"],
    plusCircleSolid: _plusCircleSolid["default"],
    warning: _warning["default"],
    warningSolid: _warningSolid["default"],
    "void": _voidIcon["default"]
  },
  Shapes: {
    heart: _heart["default"],
    heartSolid: _heartSolid["default"],
    star: _star["default"]
  },
  Arrows: {
    arrowUpRight: _arrowUpRight["default"],
    autoReload: _autoReload["default"],
    caretDown: _caretDown["default"],
    caretDownCircle: _caretDownCircle["default"],
    caretDownCircleSolid: _caretDownCircleSolid["default"],
    chevronLeft: _chevronLeft["default"],
    chevronRight: _chevronRight["default"],
    circularArrow: _circularArrow["default"],
    externalLink: _externalLink["default"],
    rightArrowCircle: _rightArrowCircle["default"],
    transfer: _transfer["default"]
  },
  Transaction: {
    addMoney: _addMoney["default"],
    coupon: _coupon["default"],
    creditCard: _creditCard["default"],
    digitalPayment: _digitalPayment["default"],
    filledCard: _filledCard["default"],
    mobileOrdering: _mobileOrdering["default"],
    receipt: _receipt["default"],
    starbucksCard: _starbucksCard["default"],
    tipJar: _tipJar["default"]
  },
  Miscellaneous: {
    birthday: _birthday["default"],
    cellPhone: _cellPhone["default"],
    evenings: _evenings["default"],
    groceryCode: _groceryCode["default"],
    lifeSaver: _lifeSaver["default"],
    magicWand: _magicWand["default"],
    mask: _maskClear["default"],
    moonZzz: _moonZzz["default"],
    personal: _personal["default"],
    phone: _phone["default"],
    scroll: _scroll["default"],
    sparkles: _sparkles["default"],
    starShower: _starShower["default"],
    trophy: _trophy["default"]
  },
  Transportation: {
    bike: _bike["default"],
    car: _car["default"],
    directions: _directions["default"],
    geolocate: _geolocate["default"],
    transit: _transit["default"],
    walk: _walk["default"]
  },
  'Misc. Starbucks': {
    digitalRewards: _digitalRewards["default"],
    powermat: _powermat["default"],
    socialMediaFacebook: _socialMediaFacebook["default"],
    socialMediaInstagram: _socialMediaInstagram["default"],
    socialMediaPinterest: _socialMediaPinterest["default"],
    socialMediaSpotify: _socialMediaSpotify["default"],
    socialMediaTwitter: _socialMediaTwitter["default"],
    socialMediaYoutube: _socialMediaYoutube["default"]
  },
  Cafe: {
    clover: _clover["default"],
    fizzio: _fizzio["default"],
    laBoulange: _laBoulange["default"],
    mercato: _mercato["default"],
    nitroBrew: _nitroBrew["default"],
    oleato: _oleato["default"],
    openNow: _openNow["default"],
    ovenWarmed: _ovenWarmed["default"],
    pickupCurbside: _pickupCurbside["default"],
    pickupDriveThru: _pickupDriveThru["default"],
    pickupInStore: _pickupInStore["default"],
    pickupOutdoor: _pickupOutdoor["default"],
    reserve: _reserve["default"],
    seatingCafe: _seatingCafe["default"],
    seatingOutdoor: _seatingOutdoor["default"],
    store: _store["default"],
    twentyFourHours: _twentyFourHours["default"],
    verismo: _verismo["default"],
    wifi: _wifi["default"]
  }
};
var _default = exports["default"] = paths;